module.exports = __webpack_public_path__ + "img/delivery-time.41ad309f.png";